import { getOrCreateDeviceId } from '../storage/deviceIdentity';
import { getSettings } from '../storage/settingsStorage';
import { prepareInitialMediaPlan } from './mediaData';
import { createMediaPreload, getMediaPreloadKey } from './mediaPreload';

const SESSION_SEEN_MEDIA_KEY_PREFIX = 'ai-or-not:session-seen-media';
const SESSION_GAME_STATE_KEY_PREFIX = 'ai-or-not:game-state';

let startupPreload = {
  key: '',
  preload: null,
};

function readSessionSeenMediaIds(deviceId) {
  try {
    const storedIds = window.sessionStorage.getItem(`${SESSION_SEEN_MEDIA_KEY_PREFIX}:${deviceId}`);
    const parsedIds = storedIds ? JSON.parse(storedIds) : [];

    return Array.isArray(parsedIds) ? new Set(parsedIds) : new Set();
  } catch {
    return new Set();
  }
}

function readSessionGameState(deviceId) {
  try {
    const storedState = window.sessionStorage.getItem(`${SESSION_GAME_STATE_KEY_PREFIX}:${deviceId}`);
    const parsedState = storedState ? JSON.parse(storedState) : null;

    if (!parsedState || !Array.isArray(parsedState.mediaItems)) {
      return null;
    }

    return {
      mediaItems: parsedState.mediaItems,
      roundIndex: Number(parsedState.roundIndex) || 0,
    };
  } catch {
    return null;
  }
}

function setStartupPreload(preloadTarget) {
  const preloadKey = getMediaPreloadKey(preloadTarget);

  if (!preloadKey || startupPreload.key === preloadKey) {
    return;
  }

  const preload = createMediaPreload(preloadTarget, getSettings());

  if (!preload) {
    return;
  }

  if (startupPreload.preload) {
    startupPreload.preload.dispose();
  }

  startupPreload = {
    key: preloadKey,
    preload,
  };
}

export function preloadFirstGameMediaAtStartup() {
  if (typeof window === 'undefined') {
    return;
  }

  const deviceId = getOrCreateDeviceId();
  const savedGameState = readSessionGameState(deviceId);

  if (savedGameState?.mediaItems[savedGameState.roundIndex]) {
    setStartupPreload(savedGameState.mediaItems[savedGameState.roundIndex]);
    return;
  }

  prepareInitialMediaPlan(deviceId, readSessionSeenMediaIds(deviceId), 0)
    .then((mediaPlan) => {
      setStartupPreload(mediaPlan.mediaItems[0]);
    })
    .catch(() => {});
}
